import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from 'react-bootstrap/Card';
import { styles } from 'yankees-react-utils';

export const reportCardBorder = `1px solid ${styles.pSBC(-0.1, styles.theme.background.geyser)}`;
export const StyledReportCard = styled(Card)`
    && {
        border: ${reportCardBorder};
        margin-top: 10px;
    }
`;

const ReportCard = ({ className, title, children, body, titleIsHtml, ...rest }) => (
    <StyledReportCard className={className} body={body} {...rest}>
        {title && titleIsHtml && <h4 dangerouslySetInnerHTML={{ __html: title }} />}
        {title && !titleIsHtml && <h4 className="clearfix">{title}</h4>}
        {children}
    </StyledReportCard>
);

ReportCard.propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    titleIsHtml: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]).isRequired,
    body: PropTypes.bool,
};

ReportCard.defaultProps = {
    className: undefined,
    title: undefined,
    titleIsHtml: false,
    body: true,
};

export default ReportCard;
